import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

export const authApi = createApi({
  reducerPath: "authApi",
  baseQuery: fetchBaseQuery({ baseUrl: "https://n6t.in/console/auth" }),
  endpoints: (builder) => ({
    authLogin: builder.mutation({
      query: (body) => ({
        url: "/login",
        method: "POST",
        body,
      }),
    }),
    authRefresh: builder.query({
      query: () => "/refresh",
    }),
    authLogout: builder.mutation({
      query: () => ({
        url: "/logout",
        method: "POST",
      }),
    }),
    // authUpdatePassword: builder.mutation({
    //     query: (body) => ({
    //         // Bearer token is to be added in the headers
    //         url: '/update-password',
    //         method: 'PUT',
    //         body,
    //     }),
    // }),
  }),
});

export const {
  useAuthLoginMutation,
  useAuthRefreshQuery,
  useAuthLogoutMutation,
  useAuthUpdatePasswordMutation,
} = authApi;
